module.exports = __webpack_public_path__ + "303b572f8ac7fca5e14d351e3a53d835.svg";